import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-100">
      <div className="w-full max-w-md">
        <div className="bg-white border border-zinc-200 rounded-sm p-8">
          <div className="mb-8">
            <h1
              data-testid="login-title"
              className="text-2xl font-semibold tracking-tight text-zinc-900 font-heading"
            >
              Platform Rekonsiliasi
            </h1>
            <p className="text-sm text-zinc-500 mt-1 font-body">
              Data Panel ke Google Sheets
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <div
                data-testid="login-error"
                className="bg-red-50 border border-red-200 text-red-700 text-sm p-3 rounded-sm"
              >
                {error}
              </div>
            )}

            <div className="space-y-2">
              <Label htmlFor="email" className="text-xs font-semibold uppercase tracking-widest text-zinc-500">
                Email
              </Label>
              <Input
                id="email"
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@example.com"
                className="rounded-sm border-zinc-300 focus:ring-1 focus:ring-zinc-900"
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="text-xs font-semibold uppercase tracking-widest text-zinc-500">
                Password
              </Label>
              <Input
                id="password"
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                className="rounded-sm border-zinc-300 focus:ring-1 focus:ring-zinc-900"
                required
              />
            </div>

            <Button
              data-testid="login-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-zinc-900 text-white hover:bg-zinc-800 rounded-sm h-10"
            >
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>
        </div>

        <p className="text-center text-xs text-zinc-400 mt-4 font-mono">
          Internal Operations Platform v1.0
        </p>
      </div>
    </div>
  );
}
